@if (!!value) {
  <topo-phone-input
    [formControl]="control"
    size="sm" />
} @else {
  <div>---</div>
}
